<template>
  <div class="border-bottom-stroke-dark-soft">
    <div
      class="py-16"
      @click="toogleStates()"
      :class="{ 'js-review-drop': text === 'Отзывы' }"
    >
      <div class="grid-row d-flex_middle">
        <div class="grid-col grid-col_full">
          <div class="fw-semibold fs-20">{{ text }}</div>
        </div>
        <div class="grid-col">
          <div
            class="active-rotate-180"
            v-bind:class="{ 'is-active': isActive }"
          >
            <Icon iconName="icon-chevron-down" />
          </div>
        </div>
      </div>
    </div>

    <div class="pb-24" v-if="isActive">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
export default {
  name: "Dropdown",
  components: {
    Icon,
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.isOpen,
    };
  },
  methods: {
    toogleStates() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
